module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"annotationDialog.dialogTitle":"Annotations"}}')
  delete Component.options._Ctor
}
